import React, { Fragment } from "react"
import PropTypes from "prop-types"
import collect from "collect.js"
import UserManduCreate from "./UserManduCreate"
import UserManduEdit from "./userManduEdit"
import SectionCompanyUserAccess from "../CompanyUserAccess/CompanyUserAccess"
import { ROLE_MANDU_SUPER_ADMIN } from "../../../../utils/constants"

const setIdUserToItemsCompany = (data, id) => {
  let collectCompanies = collect(data)
  collectCompanies = collectCompanies.map((item) => {
    const itemNew = item
    itemNew.id = id
    return itemNew
  })

  return collectCompanies.sortBy("name").toArray()
}

const PermissionRender = (props) => {
  const { companiesUserAccesses } = props.currentData
  const { companies } = props.userCreate
  const { id } = props.currentData
  return (
    <div className="AdministratorCompaniesForm-body-content-section">
      <SectionCompanyUserAccess
        items={setIdUserToItemsCompany(companies, id)}
        dataSource={setIdUserToItemsCompany(companiesUserAccesses, id)}
        {...props}
      />
    </div>
  )
}

const UserMandu = (props) => {
  const { tab, isNew } = props

  switch (tab) {
    case "1":
      if (props.currentData.id_role === ROLE_MANDU_SUPER_ADMIN && !isNew)
        return <UserManduEdit {...props} />

      if (isNew)
        return (
          <UserManduCreate
            {...props}
            setIdUserToItemsCompany={setIdUserToItemsCompany}
          />
        )

      if (!isNew) return PermissionRender(props)
      break
    case "2":
      if (isNew) {
        return <UserManduCreate {...props} />
      }
      return <UserManduEdit {...props} />
    default:
      return <Fragment />
  }
}

UserMandu.propTypes = {
  isNew: PropTypes.bool,
  tab: PropTypes.string,
}

export default UserMandu
